import MTable from "../../../../components/mtable"

export default function CompanyUsers({companyId}) {
    
    const usersMapper = {columns: [
        {
            label: "Name",
            value: (item) => `${item.firstName} ${item.lastName}`
        },
        {
            label: "Email",
            value: (item) => item.email
        }
    ]}
    
    return(
        <>
            <div className="flex space-between center gap-xs v-spacer-m">
                <p className="section-title">Managers</p>
            </div>
            {companyId && <MTable path={`companies/${companyId}/managers`} mapper={usersMapper}/>}
        </>
    )
}